import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import { House } from 'lucide-react';
import { PageShareTitle } from '../../lib/shareTitle';

export const homeRouteRef = createRouteRef();

/**
 * The personalized Home page, mounted at the app root (`/`) — the catalog
 * keeps its default `/catalog` path. Extension id: `page:home`. The
 * title/icon/routeRef outputs are what surface it as the sidebar's Home
 * item (taken explicitly in modules/nav/Sidebar.tsx).
 */
export const homePage = PageBlueprint.make({
  params: {
    path: '/',
    title: 'Home',
    // Lucide House, matching the rail's own glyph set (the rail renders its
    // own icon, but the nav-item output still carries one for any consumer).
    icon: <House size={20} strokeWidth={1.75} />,
    routeRef: homeRouteRef,
    // The page renders its own greeting Header; skip the PageLayout one.
    noHeader: true,
    loader: () =>
      import('./HomePage').then(m => (
        <PageShareTitle title="Home">
          <m.HomePage />
        </PageShareTitle>
      )),
  },
});

export const homePlugin = createFrontendPlugin({
  pluginId: 'home',
  extensions: [homePage],
});
